/*
 * 拼接信息的坑：
 * 产品设计中，信息拼接规则是以 “角色” 或者 “页面”两种条件的组合或独立
 * 因此，每个页面都有不同的显示格式，很难做到重用，使用前需要先跟产品经理确认每一个页面和每一个模块的规则
 * 如果规则超出了目前的模版数量，则需要自行添加新模版
*/

import store from 'store'

// 动作
let actionType = {
    approve: '审核',
    archive: '归档',
    create: '创建',
    delete: '删除',
    edit: '编辑',
    join: '加入',
    remove: '移除',
    supplement: '补充'
}

let converType = {
    // -- 商务经理、维保负责人 -----------------------------------
    business_manager: {
        // 默认：岗位 + 姓名 + 动作 + 模块 + 项目名称
        default: '{operator_roles}{operator_name}{action_type}了{type_name}{contract_name}',
        // 审核：岗位 + 姓名 + 动作 + 模块 + （审核结果+审核不通过原因） + 项目名称
        approve: '{operator_roles}{operator_name}{action_type}了{type_name}{content}{contract_name}'
    },
    // 维保负责人
    maintain_principal: {},

    // -- 工程公司、管理员 -----------------------------------
    supervisor: {
        // 默认：你 + 动作 + 模块 + 项目名称
        default: '你{action_type}了{type_name}{contract_name}',
        // 审核：你 + 动作 + 模块 + （审核结果+审核不通过原因） + 项目名称
        approve: '你{action_type}了{type_name}{content}{contract_name}'
    },
    admin: {},

    // -- 项目关键动态（仅针对项目的消息） -----------------------------------
    project: {
        // 默认：岗位 + 姓名 + 动作 + 模块
        default: '{operator_roles}{operator_name}{action_type}了{type_name}',
        // 审核：岗位 + 姓名 + 动作 + 模块 + （审核结果+审核不通过原因）
        approve: '{operator_roles}{operator_name}{action_type}了{type_name}{content}'
    }
}
converType.maintain_principal = { ...converType.business_manager }
converType.admin = { ...converType.supervisor }

function filterVal(key, info) {
    let val = ''
    switch (key) {
        // 项目
        case 'contract_name':
            val = info[key] ? '[' + info[key] + ']' : ''
            break
        // 岗位
        case 'operator_roles':
            val = info[key][0] || ''
            if (val && val !== '') val += '，'
            break
        // 动作
        case 'action_type':
            val = actionType[info[key]] || ''
            break
        // 默认
        default:
            val = info[key]
            break
    }
    return val
}

/**
 * 自动拼接消息内容
 * @param {object} msgInfo  消息拼接字段
 * @param {string} typeName 消息组合类型（与角色相关，非必填）
 * @desc
 *      默认 typeName 会从用户信息中获取，如手动输入 typeName 则会优先使用手动输入的值
 */
export function conver(msgInfo, typeName) {
    if (!msgInfo || !store.state.user || !store.state.user.userMsg) return

    let userMsg = store.state.user.userMsg
    let type = converType[typeName || userMsg.role_list[0]]
    let tpl = type[msgInfo.action_type] || type['default']
    Object.keys(msgInfo).forEach(key => {
        let val = filterVal(key, msgInfo)
        tpl = tpl.replace(new RegExp('{' + key + '}'), val)
    })
    return tpl
}



// WEBPACK FOOTER //
// ./src/common/msgConver.js